import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  getActiveSection,
  getSelectedFolder,
  getPublishedTiers,
  getPublishedTierId,
  getIsRootFolder,
  getIsTierPage,
} from '../../../../selectors/studio';
import { Props } from './PublishedHeader';

export type StateProps = Pick<
  Props,
  | 'activeSection'
  | 'selectedFolder'
  | 'selectedTierId'
  | 'availableTiers'
  | 'isRootFolder'
  | 'isTierPage'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  activeSection: getActiveSection(state),
  selectedFolder: getSelectedFolder(state)!,
  selectedTierId: getPublishedTierId(state),
  availableTiers: getPublishedTiers(state),
  isRootFolder: getIsRootFolder(state),
  isTierPage: getIsTierPage(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
